import { useEffect, useState } from "react";
import {
  CommandDialog, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem
} from "@/components/ui/command";
import { api } from "@/lib/api";
import { Users, ListChecks, FileText } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function GlobalSearch({ open, onOpenChange }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState({ clients: [], tasks: [], documents: [] });
  const nav = useNavigate();

  useEffect(() => {
    if (!q.trim()) { setResults({ clients: [], tasks: [], documents: [] }); return; }
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/search?q=${encodeURIComponent(q)}`);
        setResults(data);
      } catch (err) { console.error("Global search failed", err); }
    }, 200);
    return () => clearTimeout(t);
  }, [q]);

  function go(path) { onOpenChange(false); setQ(""); nav(path); }

  return (
    <CommandDialog open={open} onOpenChange={onOpenChange}>
      <CommandInput data-testid="global-search-input" value={q} onValueChange={setQ} placeholder="Search PAN, GSTIN, client, task, document…" />
      <CommandList>
        <CommandEmpty>No results. Try a PAN, GSTIN or client name.</CommandEmpty>
        {results.clients.length > 0 && (
          <CommandGroup heading="Clients">
            {results.clients.map(c => (
              <CommandItem key={c.id} onSelect={() => go(`/clients/${c.id}`)}>
                <Users className="w-4 h-4 mr-2 text-blue-600" />
                <div>
                  <div className="text-sm font-medium">{c.client_name}</div>
                  <div className="text-[10px] font-mono text-muted-foreground">{c.pan || "—"} · {c.gstin || "—"}</div>
                </div>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
        {results.tasks.length > 0 && (
          <CommandGroup heading="Tasks">
            {results.tasks.map(t => (
              <CommandItem key={t.id} onSelect={() => go(`/tasks?open=${t.id}`)}>
                <ListChecks className="w-4 h-4 mr-2 text-emerald-600" />
                <div>
                  <div className="text-sm font-medium">{t.title}</div>
                  <div className="text-[10px] text-muted-foreground">{t.department} · {t.status}</div>
                </div>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
        {results.documents.length > 0 && (
          <CommandGroup heading="Documents">
            {results.documents.map(d => (
              <CommandItem key={d.id} onSelect={() => go(`/documents`)}>
                <FileText className="w-4 h-4 mr-2 text-amber-600" />
                <div className="text-sm">{d.name}</div>
              </CommandItem>
            ))}
          </CommandGroup>
        )}
      </CommandList>
    </CommandDialog>
  );
}
